module.exports = function getResource(label, vars = []) {
    let resources = {
        ccReward: 'Credit Card Reward*',
        exp: 'Exp.'
    };

    return resources[label];
};
